export const scaleToCssString = ({ k }) => `scale(${k})`

export const scaleToPercentageString = (max, scale) => `${Math.round((scale / max) * 100, 0)}%`
